import dayjs from "dayjs";
import { FormattedMessage } from "react-intl";

const ShowPersonalDetailsAsian = (props: any): React.JSX.Element => {
  const { user } = props;
  let startTime = dayjs(user["lastLogin"]).format("DD/MM/YYYY HH:mm");
  return (
    <div className="personal-details__component--read-only regular-user personal-details--asian">
      {/* left column */}
      <div className="col">
        <div>
          <span className="personal-details__label">
            <FormattedMessage tagName="span" id="settings-username" />
          </span>
          <span className="personal-details__text">{props.username}</span>
        </div>
        <div>
          <span className="personal-details__label">
            <FormattedMessage tagName="span" id="settings-title" />
          </span>
          <span className="personal-details__text">{props.title}</span>
        </div>
        <div>
          <span className="personal-details__label">
            <FormattedMessage tagName="span" id="settings-firstname" />
          </span>
          <span className="personal-details__text">{props["firstName"]}</span>
        </div>
        <div>
          <span className="personal-details__label">
            <FormattedMessage tagName="span" id="settings-lastname" />
          </span>
          <span className="personal-details__text">{props["lastName"]}</span>
        </div>
        <div>
          <span className="personal-details__label">
            <FormattedMessage tagName="span" id="settings-birth" />
          </span>
          <span className="personal-details__text">{props["dateOfBirth"]}</span>
        </div>
        <div>
          <span className="personal-details__label">
            <FormattedMessage tagName="span" id="settings-currency" />
          </span>
          <span className="personal-details__text">
            {props["currencyCode"]}
          </span>
        </div>
      </div>
      {/* right column */}
      <div className="col">
        <div>
          <span className="personal-details__label">
            <FormattedMessage tagName="span" id="profile-last-login" />
          </span>
          <span className="personal-details__text">{startTime}</span>
        </div>

        <div>
          <span className="personal-details__label">
            <FormattedMessage tagName="span" id="profile-last-last-ip" />
          </span>
          <span className="personal-details__text">
            {user["lastLoginIpAddress"]}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ShowPersonalDetailsAsian;
